import EventSubscriber from '../events/EventSubscriber';
import EventPublisher from '../events/EventPublisher';
import AppEvent from '../events/AppEvent';
import Component from './Component';

abstract class ListeningComponent<P, S> extends Component<P, S> implements EventSubscriber {

	public constructor () {
		super();
	}

	componentDidMount () {
		EventPublisher.getInstance().subscribe(this);
	}

	componentWillUnmount () {
		EventPublisher.getInstance().unsubscribe(this);
	}

	public abstract async processEvent (event: AppEvent): Promise<void>;
}

export default ListeningComponent;


// WEBPACK FOOTER //
// ./code/foundation/components/ListeningComponent.ts